import React from "react";

const TermsDoc = (props) => {
  return (
    <div className="text-justify">
      <p>Clowds.io Terms of Service</p> <br />
      <p>Effective: April 1, 2023</p> <br />
      <p>
        Thanks for using Clowds.io! <br /> Our mission is to provide peace of
        mind for families, friends and acquaintances by enabling them to leave
        behind what's important— for only their select individuals,
        encrypted on the blockchain and locked until after they're gone.
        These terms of service ("Terms") cover your use and access
        to our services, client software and websites ("Services&quot;)
        globally. Our Privacy Policy below explains how we collect and use
        your information while our Acceptable Use Policy below outlines
        your responsibilities when using our Services. By using our Services,
        you're agreeing to be bound by these Terms, our Privacy Policy,
        and Acceptable Use Policy.
      </p>  
      <br />
      <p>
        Your Stuff  & Your Permissions When you use our Services, you provide
        us with things like your files, content, messages, contacts, and so on
        ("Your Stuff"). Your Stuff is yours. These Terms don't
        give us any rights to Your Stuff except for the limited rights that
        enable us to offer the Services. We need your permission to do things
        like hosting Your Stuff, backing it up, and sharing it with those you
        have permitted (Recipients) when you provide their contact
        information— whether it's unlocked or locked in their boxes.
        Our Services also provide you with features like sharing, searching,
        accessing boxes, document previews, optical character recognition (OCR),
        easy sorting and organization, and personalization. To provide these and
        other features, Clowds.io accesses, stores, and scans Your Stuff. You
        give us permission to do those things, and this permission extends to
        our affiliates and trusted third parties we work with.
      </p>  
      <br />
      <p>
        Your Responsibilities Your use of our Services must comply with our
        Acceptable Use Policy. Content in the Services may be protected by
        others'intellectual property rights. Please don't copy,
        upload, download, or share content unless you have the right to do so.
        Clowds.io may review your conduct and content for compliance with these
        Terms and our Acceptable Use Policy. We aren't responsible for the
        content people post and share via the Services nor are we responsible
        for the accessibility and retrieval of Content from intended recipients,
        whether it is unlocked purposely or mistakenly unlocked. Help us keep
        Your Stuff protected. Safeguard your password to the Services, and keep
        your account information current. Don't share your account
        credentials or give others access to your account. You may use our
        Services only as permitted by applicable law, including export control
        laws and regulations. Finally, to use our Services, you must be at least
        13 if you reside in the United States, and 16 if you reside anywhere
        else. If the law where you reside requires that you must be older in
        order for Clowds.io to lawfully provide the Services to you without
        parental consent (including use of your personal data), then you must be
        that older age. <br />
        • Under no circumstances should you upload confidential information
        such as passwords or logins, including crypto keys, bank account or
        investment logins and passwords <br />
        • Under no circumstances should you upload any illegal content or
        files <br />
        • Clowds.io assumes no risk or liability for any data breeches,
        accessed files by incorrect individuals, user misconduct, hacked
        information, file or account tampering. <br />
        • By using the clowds.io service and platform, you are accepting
        the terms and conditions set forth.
      </p>  
      <br />
      <p>
        Software <br /> Some of our Services allow you to download client software
        ("Software") which may update automatically. So long as you
        comply with these Terms, we give you a limited, nonexclusive,
        nontransferable, revocable license to use the Software, solely to access
        the Services. To the extent any component of the Software may be offered
        under an open source license, we'll make that license available to
        you and the provisions of that license may expressly override some of
        these Terms. Unless the following restrictions are prohibited by law,
        you agree not to reverse engineer or decompile the Services, attempt to
        do so, or assist anyone in doing so.
      </p>  
      <br />
      <p>
        Beta Services <br /> We sometimes release products and features that
        we're still testing and evaluating ("Beta Services").
        Beta Services are labeled "alpha," "beta,"
        "preview," "early access," or
        "evaluation" (or with words or phrases with similar
        meanings) and may not be as reliable as Clowds.io's other
        services. Beta Services are made available so that we can collect user
        feedback, and by using our Beta Services, you agree that we may contact
        you to collect such feedback. Beta Services are confidential until
        official launch. If you use any Beta Services, you agree not to disclose
        any information about those Services to anyone else without our
        permission.
      </p>  
      <br />
      <p>
        Additional Features <br /> From time to time, Clowds.io will add additional
        features to enhance the user experience of our storage service at no
        additional charge. However, these free features may be withdrawn without
        further notice.
      </p>  
      <br />
      <p>
        Our Stuff <br />The Services are protected by copyright, trademark, and other
        US and foreign laws. These Terms don't grant you any right, title,
        or interest in the Services, others'content in the Services,
        Clowds.io trademarks, logos and other brand features. We welcome
        feedback, but note that we may use comments or suggestions without any
        obligation to you.
      </p>  
      <br />
      <p>
        Copyright<br /> We respect the intellectual property of others and ask that
        you do too. We respond to notices of alleged copyright infringement if
        they comply with the law, and such notices should be reported using our
        Copyright Policy below. We reserve the right to delete or disable
        content alleged to be infringing and terminate accounts of repeat
        infringers. Our contact for notice of alleged copyright infringement on
        the Services can be submitted to through: hello.clowds@gmail.com.
      </p>  
      <br />
      <p>
        Purchases <br />
        Billing.  You can increase your storage space on new boxes for purchase.
        We'll automatically bill you when you opt in to purchase a new
        box. You're responsible for all applicable taxes, and we'll
        charge tax when required to do so. Some countries have mandatory local
        laws regarding your cancellation rights, and this paragraph
        doesn't override these laws. 
        <br />Cancellation. You may delete
        your account or any boxes purchased but we will not be able to refund
        any purchases made. Refunds are only issued if required by law. For
        any questions with your account, please contact: hello.clowds@gmail.com.
        <br />Changes. We may change the fees/prices per box and storage tier at
        any time which will affect future purchases. These price changes are due
        to factors such as changes to our product offerings, changes to our
        business, or changes in economic conditions. We'll give you notice
        of these changes via our website landing page and/or to the email
        address associated with your account.
      </p>  
      <br />
      <p>
        Termination <br />
        You're free to stop using our Services at any time. We reserve the
        right to suspend or terminate your access to the Services with notice to
        you if: <br />
        • you're in breach of these Terms,
        <br />
        • your use of the Services would cause a real risk of harm or loss
        to us or other users, or <br />
        • you haven't purchased a box and/or accessed our Services
        for 12 consecutive months. We'll provide you with reasonable
        advance notice via the email address associated with your account to
        remedy the activity that prompted us to contact you and give you the
        opportunity to export Your Stuff from our Services. If after such notice
        you fail to take the steps we ask of you, we'll terminate or
        suspend your access to the Services. We won't provide notice or an
        opportunity to export Your Stuff before termination or suspension of
        access to the Services where: <br />
        • you're in material breach of these Terms, <br />
        • doing so would cause us legal liability or compromise our ability
        to provide the Services to our other users, or <br />
        • we're prohibited from doing so by law. 
        <br />Discontinuation of Services<br /> We may decide to discontinue the Services in response to
        exceptional unforeseen circumstances, events beyond Clowds.io's
        control or current expectation (for example a natural disaster,
        bankruptcy or determination to shut down the business) or to comply with
        a legal requirement. If we do so, we'll give you reasonable prior
        notice so that you can export Your Stuff from our systems (we will give
        you no less than 30 days'notice where possible under the
        circumstances). If we discontinue the Services in this way we will not
        be able to refund any purchases made.
      </p>  
      <br />
      <p>
        Services "AS IS"
        <br /> We strive to provide great Services, but there are certain things
        that we can't guarantee. TO THE FULLEST EXTENT PERMITTED BY LAW,
        Clowds.io AND ITS AFFILIATES, SUPPLIERS AND DISTRIBUTORS MAKE NO
        WARRANTIES, EITHER EXPRESS OR IMPLIED, ABOUT THE SERVICES, INCLUDING ANY
        ISSUES OR ERRORS IN BOX RECIPIENTS OR BOX CREATORS IN ACCESSING FILES.
        THE SERVICES ARE PROVIDED &quot;AS IS.&quot; WE ALSO DISCLAIM ANY
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
        NON-INFRINGEMENT. Some places don't allow the disclaimers in this
        paragraph, so they may not apply to you. For example, these disclaimers
        do not override the legal protections, including statutory warranties,
        granted to consumers by EU law.
      </p>  
      <br />
      <p>
        Limitation of Liability<br />  AS OUR SERVICES, PLATFORM AND TECHNOLOGY ARE
        MERELY TO CONNECT A BOX CREATOR WITH THEIR INTENDED RECIPIENTS FOR
        ACCESSING FILES/CONTENT, WE MAKE NO CLAIMS AND HOLD NO LIABILITY FOR ANY
        DAMAGES, DATA BREACHES, PERSONAL LOSS OF OUR USERS—THIS INCLUDES
        ANY LIABILITY FOR Clowds.io's OR ITS AFFILIATES'FRAUD OR
        FRAUDULENT MISREPRESENTATION IN PROVIDING THE SERVICES. IN COUNTRIES
        WHERE THE FOLLOWING TYPES OF EXCLUSIONS AREN'T ALLOWED, WE'RE
        RESPONSIBLE TO YOU ONLY FOR LOSSES AND DAMAGES THAT ARE A REASONABLY
        FORESEEABLE RESULT OF OUR FAILURE TO USE REASONABLE CARE AND SKILL OR
        OUR BREACH OF OUR CONTRACT WITH YOU. THIS PARAGRAPH DOESN'T AFFECT
        CONSUMER RIGHTS THAT CAN'T BE WAIVED OR LIMITED BY ANY CONTRACT OR
        AGREEMENT. IF YOU ARE AN EU OR UK CONSUMER, THESE TERMS DO NOT EXCLUDE
        Clowds.io'S LIABILITY FOR LOSSES AND DAMAGES THAT ARE A RESULT OF
        OUR FAILURE TO USE REASONABLE CARE AND SKILL IN PROVIDING THE SERVICES
        OR OF OUR BREACH OF OUR CONTRACT WITH YOU, AS LONG AS THOSE LOSSES AND
        DAMAGES ARE REASONABLY FORESEEABLE. IN COUNTRIES WHERE EXCLUSIONS OR
        LIMITATIONS OF LIABILITY ARE ALLOWED, Clowds.io, ITS AFFILIATES,
        SUPPLIERS OR DISTRIBUTORS WON'T BE LIABLE FOR: <br />
        • ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY, OR
        CONSEQUENTIAL DAMAGES, OR <br />
        • ANY LOSS OF USE, DATA, BUSINESS, OR PROFITS, REGARDLESS OF LEGAL
        THEORY. THESE EXCLUSIONS OR LIMITATIONS WILL APPLY REGARDLESS OF WHETHER
        OR NOT Clowds.io OR ANY OF ITS AFFILIATES HAS BEEN WARNED OF THE
        POSSIBILITY OF SUCH DAMAGES. IF YOU USE THE SERVICES FOR ANY COMMERCIAL,
        BUSINESS, OR RE-SALE PURPOSE, Clowds.io, ITS AFFILIATES, SUPPLIERS OR
        DISTRIBUTORS WILL HAVE NO LIABILITY TO YOU FOR ANY LOSS OF PROFIT, LOSS
        OF BUSINESS, BUSINESS INTERRUPTION, OR LOSS OF BUSINESS OPPORTUNITY.
        Clowds.io AND ITS AFFILIATES AREN'T RESPONSIBLE FOR THE CONDUCT,
        WHETHER ONLINE OR OFFLINE, OF ANY USER OF THE SERVICES. OTHER THAN FOR
        THE TYPES OF LIABILITY WE CANNOT LIMIT BY LAW (AS DESCRIBED IN THIS
        SECTION), WE LIMIT OUR LIABILITY TO YOU TO THE GREATER OF $.0001 USD OR
        100% OF ANY AMOUNT YOU'VE PAID UNDER YOUR CURRENT SERVICE PLAN WITH
        Clowds.io. THIS PROVISION DOES NOT APPLY TO EU CONSUMERS WHERE
        PROHIBITED BY APPLICABLE LAW.
      </p>  
      <br />
      <p>
        Resolving Disputes <br /> Let's Try to Sort Things Out First. We
        want to address your concerns without needing a formal legal case.
        Before filing a claim against Clowds.io, you agree to try to resolve the
        dispute informally by sending us a written Notice of Dispute at
        hello.clowds@gmail.com that includes your name, a detailed description
        of the dispute, and the relief you seek. We'll try to resolve the
        dispute informally by contacting you via email. If a dispute is not
        resolved within 365 days after submission (but you must ensure we have
        confirmed receipt of the email acknowledging we've received it),
        you or Clowds.io may bring a formal proceeding. If you reside in the EU,
        the European Commission provides for an online dispute resolution
        platform, which you can access
        here: https://ec.europa.eu/consumers/odr.
      </p>  
      <br />
      <p>
        Judicial Forum for Disputes.
        <br />  You and Clowds.io agree that any judicial proceeding to
        resolve claims relating to these Terms or the Services will be brought
        in the federal or state courts of New York, New York, subject to the
        mandatory arbitration provisions below. Both you and Clowds.io consent
        to venue and personal jurisdiction in such courts. If you reside in a
        country (for example, a member state of the European Union) with laws
        that give consumers the right to bring disputes in their local courts,
        this paragraph doesn't affect those requirements. IF YOU'RE
        A U.S. RESIDENT, YOU ALSO AGREE TO THE FOLLOWING MANDATORY ARBITRATION
        PROVISIONS: We Both Agree to Arbitrate. You and Clowds.io agree to
        resolve any claims relating to these Terms or the Services through final
        and binding individual arbitration by a single arbitrator, except as set
        forth under the "Exceptions to Agreement to Arbitrate"
        below. This includes disputes arising out of or relating to the
        interpretation or application of this "Mandatory Arbitration
        Provisions" section, including its scope, enforceability,
        revocability, or validity. The arbitrator may award relief only
        individually and only to the extent necessary to redress your individual
        claim(s); the arbitrator may not award relief on behalf of others or the
        general public. Opt out of Agreement to Arbitrate. You can decline
        this agreement to arbitrate by sending an email to
        hello.clowds@gmail.com and submitting the opt-out form within 10
        days of first registering your account or agreeing to these Terms.
        Arbitration Procedures. The American Arbitration Association (AAA)
        will administer the arbitration under its Consumer Arbitration Rules.
        The AAA's rules and filing instructions are available
        at www.adr.org or by calling 1-800-778-7879. The arbitration
        will be held in the United States county where you live or work, New
        York, New York, or any other location we agree to. Arbitration Fees and
        Incentives. The AAA rules will govern payment of all arbitration
        fees. Clowds.io will not reimburse arbitration filing fees at the
        conclusion of the arbitration and will not pay other arbitration fees.
        For any other claims, the costs and fees of arbitration shall be
        allocated in accordance with the arbitration provider's rules,
        including rules regarding frivolous or improper claims. If you receive
        an arbitration award that is more favorable than any offer we make to
        resolve the claim, we will pay you $100 in addition to the award.
        Clowds.io will seek its attorneys' fees and costs in arbitration
        including if the arbitrator determines that your claim is frivolous or
        brought for an improper purpose. Exceptions to Agreement to
        Arbitrate. Either you or Clowds.io may assert claims, if they
        qualify, in small claims court in New York, New York or any United
        States county where you live or work. Either party may bring a lawsuit
        solely for injunctive relief to stop unauthorized use or abuse of the
        Services, or intellectual property infringement (for example, trademark,
        trade secret, copyright, or patent rights) without first engaging in
        arbitration or the informal dispute-resolution process described above.
        If the agreement to arbitrate is found not to apply to you or your
        claim, you agree to the exclusive jurisdiction of the state and federal
        courts in New York, New York to resolve your claim. NO CLASS OR
        REPRESENTATIVE ACTIONS. You may only resolve disputes with us on an
        individual basis, and may not bring a claim as a plaintiff or a class
        member in a class, consolidated, or representative action. Class
        arbitrations, class actions, private attorney general actions, and
        consolidation with other arbitrations aren't allowed.
        Severability. If any part of this "Mandatory Arbitration
        Provisions" section is found to be illegal or unenforceable, the
        remainder will remain in effect, except that if a finding of partial
        illegality or unenforceability would allow class or representative
        arbitration, this "Mandatory Arbitration Provisions" section
        will be unenforceable in its entirety. If you are found to have a
        non-waivable right to bring a particular claim or to request a
        particular form of relief that the arbitrator lacks authority to redress
        or award according to this "Mandatory Arbitration
        Provisions" section, including public injunctive relief, then only
        that respective claim or request for relief may be brought in court, and
        you and we agree that litigation of any such claim or request for relief
        shall be stayed pending the resolution of any individual claim(s) or
        request(s) for relief in arbitration. <br />
        Controlling Law <br /> These Terms will
        be governed by New York law except for its conflicts of laws principles.
        However, some countries (including those in the European Union) have
        laws that require agreements to be governed by the local laws of the
        consumer's country. This paragraph doesn't override those laws.
        <br />Entire Agreement <br />These Terms constitute the entire agreement between you
        and Clowds.io with respect to the subject matter of these Terms, and
        supersede and replace any other prior or contemporaneous agreements, or
        terms and conditions applicable to the subject matter of these Terms.
        Our past, present, and future affiliates and agents can invoke our
        rights under this agreement in the event they become involved in a
        dispute with you. Otherwise, these Terms do not give rights to any third
        parties.<br /> Waiver, Severability  & Assignment<br /> Clowds.io's failure
        to enforce a provision is not a waiver of its right to do so later. If a
        provision is found unenforceable, the remaining provisions of the Terms
        will remain in full effect and an enforceable term will be substituted
        reflecting our intent as closely as possible. You may not assign any of
        your rights under these Terms, and any such attempt will be void.
        Clowds.io may assign its rights to any of its affiliates or
        subsidiaries, or to any successor in interest of any business associated
        with the Services. Modifications We may revise these Terms from time to
        time to better reflect: <br />
        • changes to the law, <br />
        • new regulatory requirements, or <br />
        • improvements or enhancements made to our Services. If an update
        affects your use of the Services or your legal rights as a user of our
        Services, we'll notify you prior to the update's effective date by
        sending an email to the email address associated with your account or
        via an in-product notification. These updated terms will be effective no
        less than 90 days from when we notify you. If you don't agree to
        the updates we make, please cancel your account and stop using the
        Services before the updated Terms become effective. We will not offer
        any refunds based on the amounts you have paid for our Services and your
        account cancellation date. By continuing to use or access the Services
        after the updates come into effect, you agree to be bound by the revised
        Terms.
      </p>  
      <br />
      <p>
        Thanks for using Clowds.io!
        <br /> Here we describe how we collect, use, and handle your personal
        data when you use our websites, software, and services
        ("Services"). What  & Why We collect and use the
        following information to provide, improve, protect, and promote our
        Services. Account information. We collect, and associate with your
        account, the information you provide to us when you do things such as
        sign up for your account, assigns box recipients, and set up two-factor
        authentication (like your name, email address, phone number, payment
        info, and physical address). Your Stuff. Our Services are designed
        as a simple way for you to store your files, documents, photos,
        comments, messages, and so on ("Your Stuff"), collaborate
        with others, and work across multiple devices and services, and send
        them to your specified recipient(s). To make that possible, we store,
        process, and transmit Your Stuff as well as information related to it to
        your intended Recipient(s). This related information includes
        your profile information that makes it easier to share Your
        Stuff with others, as well as things like the size of the file, the time
        it was uploaded, and usage activity. The following provides the broad
        user flow and backend actions that take place in order for files to be
        shared: 1. Create new box selected from Creator 2. Box payment must be
        successfully completed 3. Content uploaded into Box, Box Name is
        created, email and SMS number is added to box 4. Box is sent to
        Recipient 5. Recipient receives email to sign up and register for the
        box. Unique URL Box sign up link is provided to recipient 6. Recipient
        registers with the platform 7. When ready, Recipient clicks
        "Unlock Box" within their recipient portal (within the
        Recipient portal/interface, the box they have been sent shows a button
        "Unlock Box") 8. If Creator is Alive: Creator receives both
        email and SMS text message and has 14 days to make a selection. If they
        are still alive, they click "Approve Unlock" or
        "Reject Unlock." 1. If Creator clicks in email
        "Approve Unlock" or SMS texts "1-Approve Unlock"
        then the box is automatically unlocked for Recipient right away. 2. If
        Creator clicks in email "Reject Unlock" or SMS texts
        "2- Reject Unlock" then the box remains locked and the
        Recipient is given an alert that they have 2 more additional
        false/incorrect attempts to unlock box- they must only attempt to unlock
        box after Creator has passed. 3. Recipient has 2 more incorrect attempts
        so this must be captured by the smart contract. 9. OR If Creator has
        Passed: Creator receives both email and SMS text message and has 14 days
        to make a selection (but since they are not alive this will pass without
        action). 1. Recipient receives a note and sms text after 14 days have
        passed without Creator action, which says: "Please click
        'Unlock Box'once more to access box" (the
        "Unlock Box" link is in the email and SMS text is
        "text 1- to unlock box" 2. Once the recipient clicks
        'Unlock Box" then the Creator receives an email and SMS text
        to "Approve Unlock" or "Reject Unlock." 3. 14
        days will pass since the Creator has passed and at the end of 14 days,
        the box will automatically unlock for the Recipient. Contacts. By
        agreeing to these terms, you are also agreeing to give us access to your
        contacts (both email and SMS text number) to enable you to share your
        box with your intended Recipient(s). We'll store those contacts on
        our servers as well as the smart contracts assigned to each of the boxes
        created. Usage information. We collect information related to how
        you use the Services, including actions you take in your account (like
        sharing, editing, viewing, creating and moving files or folders). We use
        this information to provide, improve, and promote our Services, and
        protect Clowds.io users. Device information. We also collect
        information from and about the devices you use to access the Services.
        This includes things like IP addresses, the type of browser and device
        you use, the web page you visited before coming to our sites, and
        identifiers associated with your devices. Your devices (depending on
        their settings) may also transmit location information to the Services.
        For example, we use device information to detect abuse and identify and
        troubleshoot bugs. Cookies and other technologies. We use
        technologies like cookies and pixel tags to provide, improve,
        protect, and promote our Services. For example, cookies help us with
        things like remembering your username for your next visit, understanding
        how you are interacting with our Services, and improving them based on
        that information. You can set your browser to not accept cookies, but
        this may limit your ability to use the Services. If our systems receive
        a DNT:1 signal from your browser, we'll respond to that signal. We
        may also use third-party service providers that set cookies and similar
        technologies to promote Clowds.io services. Marketing. We give
        users the option to use some of our Services free of charge. These free
        Services are made possible by the fact that some users pay for boxes. If
        you register for our Services, we will, from time to time, send you
        information from our clowds.io as well as advertising and brand
        partnership corporate partners. Users who receive these marketing
        materials can opt out at any time. If you don't want to receive a
        particular type of marketing material from us, click the
        'unsubscribe'link in the corresponding emails. You cannot,
        however, opt out of emails, SMS alerts and notifications that are used
        to enable the proper functionality of the core service. All data rates
        and charges apply and you understand these data rates and charges for
        you to receive them are at your own cost (if any applicable data rates
        and charges apply). We sometimes contact people who don't have a
        Clowds.io account. If you receive an email and no longer wish to be
        contacted by Clowds.io, you can unsubscribe and remove yourself from our
        contact list via the message itself. Bases for processing your
        data. We collect and use the personal data described above in order
        to provide you with the Services in a reliable and secure manner. We
        also collect and use personal data for our legitimate business needs. To
        the extent we process your personal data for other purposes, we ask for
        your consent in advance or require that our partners obtain such
        consent.
      </p>  
      <br />
      <p>
        With Whom We may share information as discussed below, including sell it
        to advertisers or other third parties and data partners. Others working
        for and with Clowds.io. Clowds.io uses certain trusted third
        parties (for example, providers of customer support, platform
        development, blockchain partners, payment partners and IT services) for
        the business purposes of helping us provide, improve, protect, and
        promote our Services. These third parties will access your information
        to perform tasks on our behalf, and we'll remain responsible for
        their handling of your information per our instructions. Other Clowds.io
        Companies. Clowds.io shares infrastructure, systems, and technology
        with other Clowds.io Companies to provide, improve, protect, and promote
        Clowds.io Company Services. We process your information across the
        Clowds.io Companies for these purposes, as permitted by applicable law
        and in accordance with their terms and policies. Certain features let
        you make additional information available to others.
      </p>  
      <br />
      <p>
        Other applications. <br />  You can choose to connect your
        Clowds.io account with third-party services--for example,
        via Metamask (blockchain and crypto digital wallet and payment
        platform) and Stripe (payment processing). By doing so, you're
        enabling Clowds.io and those third parties to exchange information about
        you and data in your account so that Clowds.io and those third parties
        can provide, improve, protect, and promote their services. Please
        remember that third parties'use of your information will be
        governed by their own privacy policies and terms of service. Law  &
        Order and the Public Interest. We may disclose your profile
        information that we have access to to third parties if we determine that
        such disclosure is reasonably necessary to: (a) comply with any
        applicable law, regulation, legal process, or appropriate government
        request; (b) protect any person from death or serious bodily injury; (c)
        prevent fraud or abuse of Clowds.io or our users; (d) protect
        Clowds.io's rights, property, safety, or interest; or (e) perform
        a task carried out in the public interest. Stewardship of your data is
        critical to us and a responsibility that we embrace. We believe that
        your data should receive the same legal protections regardless of
        whether it's stored on our Services or on your home
        computer's hard drive. We'll abide by the following
        Government Request Principles when receiving, scrutinizing, and
        responding to government requests (including national security requests)
        for your data: <br />
        • Be transparent <br />
        • Fight blanket requests
        <br />
        • Protect all users, and <br />
        • Provide trusted services. This report details the types and
        numbers of requests we receive from law enforcement.
      </p>  
      <br />
      <p>
        Security. <br />
         We are dedicated to keeping your information secure and testing
        for vulnerabilities. We continue to work on features to keep your
        information safe in addition to things like two-factor authentication,
        encryption of files at rest, leveraging blockchain for smart contracts
        and alerts when new devices and apps are linked to your account.
      </p>  
      <br />
      <p>
        User Controls. <br />  You can access, amend, and delete your
        personal information by logging into your Clowds.io account and going to
        your account settings page.
      </p>  
      <br />
      <p>
        Retention. <br />  When you sign up for an account with us,
        we'll retain information you store on our Services for as long as
        your account exists or as long as we need it to provide you the
        Services. If you delete your account, we'll initiate deletion of
        this information after 90 days. But please note: (1) there might be some
        latency in deleting this information from our servers and back-up
        storage; and (2) we may retain this information if necessary to comply
        with our legal obligations, resolve disputes, or enforce our agreements.
      </p>  
      <br />
      <p>
        Where Around the world. To provide you with the Services, we may
        store, process, and transmit data in the United States and locations
        around the world—including those outside your country. Data may
        also be stored locally on the devices you use to access the Services.
      </p>  
      <br />
      <p>
        Data Transfers.
        <br />  When transferring data from the European Union, the
        European Economic Area, the United Kingdom, and Switzerland, Clowds.io
        relies upon a variety of legal mechanisms, such as contracts with our
        customers and affiliates, Standard Contractual Clauses, and the
        European Commission's adequacy decisions about certain
        countries, as applicable.
      </p>  
      <br />
      <p>
        EU-U.S. <br /> Privacy Shield and Swiss-U.S. Privacy
        Shield. Clowds.io complies with the EU-U.S. and Swiss-U.S.
        Privacy Shield Frameworks as set forth by the U.S. Department of
        Commerce regarding the collection, use, and retention of personal data
        transferred from the European Union, the European Economic Area, the
        United Kingdom, and Switzerland to the United States, although Clowds.io
        does not rely on the EU-U.S. Privacy Shield or Swiss-U.S. Privacy Shield
        Frameworks as a legal basis for transfers of personal data.
      </p>  
      <br />
      <p>
        Your Control and Access of Your Data You have control over your personal
        data and how it's collected, used, and shared. For example, you
        can: <br />
        • Delete Your Stuff in your Clowds.io account or delete your
        account.  <br />
        • Change or correct personal data. You can manage your account
        and the content contained in it, as well as edit some of your personal
        data, through your accounts settings page.
        <br />
        • Access and take your data elsewhere. You can access your
        personal data from your Clowds.io account and you can delete your boxes
        and/or contents within your box. <br />
        • Object to the processing of your personal data. Depending on
        the processing activity, you can request that we stop or limit
        processing of your personal data. If you would like to submit a data
        access request or object to the processing of your personal data, please
        email us at hello.clowds@gmail.com. To request that your personal
        data be deleted, please email hello.clowds@gmail.com or simply delete
        your account.
      </p>  
      <br />
      <p>
        Clowds.io as controller or processor. Clowds.io acts as your
        service provider, controller of your personal data.
      </p>  
      <br />
      <p>
        Changes
        <br /> If we're involved in a reorganization, merger, acquisition,
        or sale of our assets, your data may be transferred as part of that
        deal. We'll notify you (for example, via a message to the email
        address associated with your account) of any such deal and outline your
        choices in that event. We may revise this Privacy Policy from time to
        time, and will post the most current version on our website. If a
        revision meaningfully reduces your rights, we will notify you.
      </p>  
      <br />
      <br />
      Contact
      <br />
      <p ref={props.targetRef}>
        Have questions or concerns about Clowds.io, our Services, and privacy?
        Contact our support at hello.clowds@gmail.com. If they can’t answer your
        question, you have the right to contact your local data protection
        supervisory authority.
      </p>  
      <br />
    </div>
  );
};

export default TermsDoc;
